import { __read, __spread } from "tslib";
import React from "react";
import { ScrollableTable, ScrollableTableBody, ScrollableTableHead, } from "./ScrollableTable";
/**
 * 支持表格内容区域滚动
 *
 * 如果遇到无法滚动情况，请尝试将该插件置于 Table 插件配置组最前
 *
```js
<Table
  records={records}
  columns={columns}
  addons={[scrollable({ maxHeight: 144 })]}
/>
```
 */
export function scrollable(options) {
    var minHeight = options.minHeight, maxHeight = options.maxHeight, minWidth = options.minWidth, _a = options.scrollHeightFactor, scrollHeightFactor = _a === void 0 ? function (props) { return [props.records.length]; } : _a, _b = options.onScrollBottom, onScrollBottom = _b === void 0 ? function () { return null; } : _b, scrollToTopOnChange = options.scrollToTopOnChange, virtualizedOptions = options.virtualizedOptions;
    if (virtualizedOptions && !virtualizedOptions.height) {
        virtualizedOptions.height = maxHeight;
    }
    var extraProps = {
        tableBoxStyle: { minWidth: minWidth },
        virtualizedOptions: virtualizedOptions || undefined,
    };
    return {
        getInfo: function () { return ({ name: "scrollable" }); },
        onInjectProps: function (props) {
            return Object.assign(extraProps, props);
        },
        /**
         * 对 div.tea-table 进行注入，提供滚动上下文
         */
        onInjectTable: function (render) { return function (props) {
            var table = render(props);
            return (React.createElement(ScrollableTable, { scrollHeightFactor: scrollHeightFactor(props), onScrollBottom: onScrollBottom, table: table }));
        }; },
        /**
         * 对 div.tea-table__body 进行注入，提供 bodyRef 用于检测滚动状态变化
         */
        onInjectBody: function (render) { return function (records, columns, topTip) {
            var args = [];
            for (var _i = 3; _i < arguments.length; _i++) {
                args[_i - 3] = arguments[_i];
            }
            var body = render.apply(void 0, __spread([records, columns, topTip], args));
            return (React.createElement(ScrollableTableBody, { body: body, bodyDeps: Array.isArray(scrollToTopOnChange)
                    ? scrollToTopOnChange
                    : [records, columns, topTip], scrollToTopOnChange: !!scrollToTopOnChange, style: { maxHeight: maxHeight, minHeight: minHeight } }));
        }; },
        /**
         * 对 div.tea-table__head 进行注入，根据滚动状态决定要不要使用 padding
         */
        onInjectHead: function (render) { return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var head = render.apply(void 0, __spread(args));
            return React.createElement(ScrollableTableHead, { head: head });
        }; },
    };
}
//# sourceMappingURL=scrollable.js.map